import { Form } from '@panwds/react-form'
import React from 'react'
import type { VFC } from 'react'
import { UAccordion, UActivationSection, UCSPComponent } from '../../activation/components'
import type { CommonStoreState } from '../../activation/store'
import type { ComponentDef } from '../../activation/renderer'

type ProfileActivationFormFormProps = {
  state: CommonStoreState
  primaryButton: {
    text: string
  }
}
const ProfileActivationForm: VFC<ProfileActivationFormFormProps> = (props: ProfileActivationFormFormProps) => {
  const section = () => {
    return <div>Hello</div>
  }
  return (

    <div>empty</div>
    // <div className='cm-w-[1000px]'>
    //   <div className='cm-flex cm-flex-row'>
    //     <Form onSubmit={(e) => { console.log('on submit', e) }} mode='onBlur' formProps={{ style: { height: '100%', width: '100%' } }}>
    //       <div>
    //         <UActivationSection title={'Select Customer Support Account'} subtitle='This account is used for the registration and support of the products and add-ons that are bundled with this subscription.'>

  //         </UActivationSection>
  //         <UCSPComponent state={props.state} actions={{}} updateTitle={(title) => { console.log('title', title) }} setAccordionOpen={(a) => { console.log('closeAccordian') }} setEditDisable={() => { console.log('disableEdit')}}></UCSPComponent>
  //       </div>
  //       <div className='cm-mt-2'>

  //       </div>
  //       <div className='cm-mt-3'>

  //       </div>
  //     </Form>
  //   </div>
  // </div>
  )
}

export default ProfileActivationForm
